export default __webpack_public_path__ + "static/media/floor-5.a840eaea.jpg";